import { createFileRoute } from "@tanstack/react-router";
import { AjustesEstoquesPage } from "@/paginas/ajustes-estoques";

export const Route = createFileRoute("/_authenticated/ajustes-estoques")({
  head: () => ({
    meta: [
      { title: "Ajustes de estoques — Milky Moo Palmares" },
      {
        name: "description",
        content: "Central de ajustes manuais de cada estoque ativo do sistema.",
      },
      { property: "og:title", content: "Ajustes de estoques — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Central de ajustes manuais de cada estoque da sorveteria.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AjustesEstoquesPage,
});
